import { Fragment } from "react"
import { Dialog, Transition } from "@headlessui/react"
import { XMarkIcon } from "@heroicons/react/24/outline"
import PropTypes from "prop-types"

const FlyoutMenu = ({ 
  isOpen, 
  onClose, 
  title, 
  subTitle, 
  size = "lg", 
  children,
  additionalHeaderContent 
}) => (
  <Transition.Root show={isOpen} as={Fragment}>
    <Dialog as="div" className="relative z-[70]" onClose={onClose}>
      <div className="fixed inset-0" />
      <div className="fixed inset-0 overflow-hidden">
        <div className="absolute inset-0 overflow-hidden">
          <div className="fixed inset-y-0 right-0 flex max-w-full pl-10 pointer-events-none">
            <Transition.Child
              as={Fragment}
              enter="transform transition ease-in-out duration-500 sm:duration-700"
              enterFrom="translate-x-full"
              enterTo="translate-x-0"
              leave="transform transition ease-in-out duration-500 sm:duration-700"
              leaveFrom="translate-x-0"
              leaveTo="translate-x-full"
            >
              <Dialog.Panel className={`pointer-events-auto w-screen max-w-${size} shadow-lg`}>
                <div className="flex flex-col h-full overflow-x-hidden overflow-y-scroll shadow-xl bg-content1">
                  <div className="px-4 py-6 bg-indigo-800 sm:px-6">
                    <div className="flex items-center justify-between">
                      <Dialog.Title className="text-xl font-semibold leading-6 text-white">
                        {title}
                      </Dialog.Title>
                    
                      <div className="flex items-center ml-3 h-7">
                        <button
                          type="button"
                          className="relative text-indigo-200 bg-indigo-800 rounded-md hover:text-white focus:outline-none"
                          onClick={onClose}
                        >
                          <span className="sr-only">Close panel</span>
                          <XMarkIcon className="w-6 h-6" aria-hidden="true" />
                        </button>
                      </div>
                    </div>
                    
                    <div className="mt-1">
                      <p className="text-indigo-300 text-md">{subTitle}</p>
                    </div>

                    {additionalHeaderContent && (
                      <div className="mt-1">{additionalHeaderContent}</div>
                    )}
                  </div>
                    
                  <div className="relative flex-1 px-4 py-6 sm:px-6">
                    {children}
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </div>
    </Dialog>
  </Transition.Root>
)

FlyoutMenu.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  size: PropTypes.string,
  children: PropTypes.node.isRequired,
  additionalHeaderContent: PropTypes.node,
}

export default FlyoutMenu